import { useReadContract } from "wagmi";

const useGetTotalNFTs = (address, abi, provider) => {
  return useReadContract({
    address: address,
    abi: abi,
    functionName: "getTotalNFTs",
    args: [],
    provider: provider,
  });
};  

export default useGetTotalNFTs;
